import * as React from 'react';

// Joy UI Components
import { Breadcrumbs, Link, Box, Typography } from "@mui/joy";

// Icons
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import TeamTable from "../tables/TeamTable";


export default function Team() {
    return (
        <>
            {/* BREADCRUMBS */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Breadcrumbs
                    size="sm"
                    aria-label="breadcrumbs"
                    separator={<ChevronRightRoundedIcon />}
                    sx={{ pl: 0 }}
                >
                    <Link
                        underline="none"
                        color="neutral"
                        href="/dashboard"
                        aria-label="Home"
                    >
                        <HomeRoundedIcon />
                    </Link>
                    <Link
                        underline="hover"
                        color="neutral"
                        href="/dashboard"
                        fontSize={12}
                        fontWeight={500}
                    >
                        Dashboard
                    </Link>
                    <Typography color="primary" fontWeight={500} fontSize={12}>
                        Team
                    </Typography>
                </Breadcrumbs>
            </Box>

            {/* PAGE HEADER */}
            <Box
                sx={{
                    display: 'flex',
                    mb: 1, // Reduced margin-bottom as the table component now has its own top margin
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Typography level="h2" component="h1">
                    Team
                </Typography>
            </Box>

            <TeamTable/>

        </>
    );
}